import { Component, ViewEncapsulation } from '@angular/core';
import { AppStateService } from '../../core/services/app-state.service';

@Component({
  selector: 'vota-layout',
  templateUrl: './vota-layout.component.html',
  styleUrl: './vota-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class VotaLayoutComponent {
  constructor(public appStateService: AppStateService) {}
}
